module.exports = __webpack_public_path__ + "img/icons8-postgresql.247d9b7f.svg";